var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-email-1093331",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.304,
    height: 18.473,
    viewBox: "0 0 25.304 18.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M172.028,136.481a4.894,4.894,0,0,0-4.88-4.879H151.6a4.894,4.894,0,0,0-4.879,4.879V145.2a4.894,4.894,0,0,0,4.879,4.879h15.545a4.894,4.894,0,0,0,4.88-4.879ZM151.6,133h15.545a3.5,3.5,0,0,1,3.311,2.405.561.561,0,0,0-.314.1l-10.77,6.2-10.77-6.2a.561.561,0,0,0-.314-.1A3.5,3.5,0,0,1,151.6,133Zm19.031,12.2a3.5,3.5,0,0,1-3.485,3.485H151.6a3.5,3.5,0,0,1-3.485-3.485V136.83l10.735,6.2a1.111,1.111,0,0,0,1.046,0l10.735-6.2Z",
    transform: "translate(-146.724 -131.602)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.dfaaf749d1e4a265f3b45d4803ecf34a.svg";
export { ForwardRef as ReactComponent };